import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M11 13h6l3 7H8l3-7Z", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M14 13V8a2 2 0 0 0-2-2H8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M4 9h2a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H4v6Z", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "LampWallDown";
const LampWallDown = memo(themed(Icon));
export {
  LampWallDown
};
//# sourceMappingURL=lamp-wall-down.js.map
